//# sourceMappingURL=ai_metrics.mjs.map
/// <reference types="./ai_metrics.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import { Ok, Error, toList, CustomType as $CustomType } from "../gleam.mjs";

export class Faithfulness extends $CustomType {}
export const AIMetric$Faithfulness = () => new Faithfulness();
export const AIMetric$isFaithfulness = (value) => value instanceof Faithfulness;

export class AnswerRelevancy extends $CustomType {}
export const AIMetric$AnswerRelevancy = () => new AnswerRelevancy();
export const AIMetric$isAnswerRelevancy = (value) =>
  value instanceof AnswerRelevancy;

export class ContextPrecision extends $CustomType {}
export const AIMetric$ContextPrecision = () => new ContextPrecision();
export const AIMetric$isContextPrecision = (value) =>
  value instanceof ContextPrecision;

export class ContextRecall extends $CustomType {}
export const AIMetric$ContextRecall = () => new ContextRecall();
export const AIMetric$isContextRecall = (value) =>
  value instanceof ContextRecall;

export class AnswerCorrectness extends $CustomType {}
export const AIMetric$AnswerCorrectness = () => new AnswerCorrectness();
export const AIMetric$isAnswerCorrectness = (value) =>
  value instanceof AnswerCorrectness;

export class AnswerSemanticSimilarity extends $CustomType {}
export const AIMetric$AnswerSemanticSimilarity = () =>
  new AnswerSemanticSimilarity();
export const AIMetric$isAnswerSemanticSimilarity = (value) =>
  value instanceof AnswerSemanticSimilarity;

export class ContextIterator extends $CustomType {}
export const AIMetric$ContextIterator = () => new ContextIterator();
export const AIMetric$isContextIterator = (value) =>
  value instanceof ContextIterator;

export const all_metrics = /* @__PURE__ */ toList([
  /* @__PURE__ */ new Faithfulness(),
  /* @__PURE__ */ new AnswerRelevancy(),
  /* @__PURE__ */ new ContextPrecision(),
  /* @__PURE__ */ new ContextRecall(),
  /* @__PURE__ */ new AnswerCorrectness(),
  /* @__PURE__ */ new AnswerSemanticSimilarity(),
  /* @__PURE__ */ new ContextIterator(),
]);

export function encode(metric) {
  if (metric instanceof Faithfulness) {
    return $json.string("faithfulness");
  } else if (metric instanceof AnswerRelevancy) {
    return $json.string("answer_relevancy");
  } else if (metric instanceof ContextPrecision) {
    return $json.string("context_precision");
  } else if (metric instanceof ContextRecall) {
    return $json.string("context_recall");
  } else if (metric instanceof AnswerCorrectness) {
    return $json.string("answer_correctness");
  } else if (metric instanceof AnswerSemanticSimilarity) {
    return $json.string("answer_semantic_similarity");
  } else {
    return $json.string("context_iterator");
  }
}

function from_string(metric) {
  if (metric === "faithfulness") {
    return new Ok(new Faithfulness());
  } else if (metric === "answer_relevancy") {
    return new Ok(new AnswerRelevancy());
  } else if (metric === "context_precision") {
    return new Ok(new ContextPrecision());
  } else if (metric === "context_recall") {
    return new Ok(new ContextRecall());
  } else if (metric === "answer_correctness") {
    return new Ok(new AnswerCorrectness());
  } else if (metric === "answer_semantic_similarity") {
    return new Ok(new AnswerSemanticSimilarity());
  } else if (metric === "context_iterator") {
    return new Ok(new ContextIterator());
  } else {
    return new Error(undefined);
  }
}

export function decoder() {
  return $decode.then$(
    $decode.string,
    (content) => {
      let $ = from_string(content);
      if ($ instanceof Ok) {
        let content$1 = $[0];
        return $decode.success(content$1);
      } else {
        return $decode.failure(new Faithfulness(), "");
      }
    },
  );
}

export function to_string(metric) {
  if (metric instanceof Faithfulness) {
    return "Faithfulness";
  } else if (metric instanceof AnswerRelevancy) {
    return "Answer relevancy";
  } else if (metric instanceof ContextPrecision) {
    return "Context precision";
  } else if (metric instanceof ContextRecall) {
    return "Context recall";
  } else if (metric instanceof AnswerCorrectness) {
    return "Answer correctness";
  } else if (metric instanceof AnswerSemanticSimilarity) {
    return "Answer semantic similarity";
  } else {
    return "Context iterator";
  }
}
